import React, { ChangeEvent, ReactElement, useState } from 'react';
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { SelfCareActivity } from '../../../../../types/entity.types';

import { getClassNames } from '../../../../../utils/util';
import { ARCHIVED, UPCOMING } from '../../../../../utils/constants';

import Button from '../../../../common/button/Button';

import { ReactComponent as DeleteIcon } from '../../../../../resources/icons/close.svg';

import './accountability-self-care.scss';
import '../accountability.scss';

type Props = {
  status: string;
  selfCareActivities: SelfCareActivity[];
  createSelfCareActivity: () => void;
  updateSelfCareActivity: (externalReference: string, value: string) => void;
  deleteSelfCareActivity: (externalReference: string) => void;
};

const AccountabilitySelfCare = ({
  status,
  selfCareActivities,
  createSelfCareActivity,
  updateSelfCareActivity,
  deleteSelfCareActivity
}: Props): ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  return (
    <div
      className={getClassNames('accountability__section', {
        closed: !open
      })}
      data-testid="accountability-self-care"
    >
      <div className="accountability__section__header">
        <p>SELF-CARE</p>
        {!open && (
          <FontAwesomeIcon
            className="accountability__section__open-icon"
            icon={faPlus}
            onClick={(): void => setOpen(true)}
            data-testid="open-icon"
          />
        )}
        {open && (
          <FontAwesomeIcon
            className="accountability__section__close-icon"
            icon={faMinus}
            onClick={(): void => setOpen(false)}
            data-testid="close-icon"
          />
        )}
      </div>
      {open && (
        <div className="accountability-self-care">
          {selfCareActivities.length > 0 && <p>Optional Self-Care Activities</p>}
          {selfCareActivities.map(
            (activity: SelfCareActivity, index: number): ReactElement => (
              <div key={index} data-testid="self-care-activity">
                <input
                  className="accountability-self-care__input"
                  value={activity.name}
                  onChange={({ target }: ChangeEvent<HTMLInputElement>): void =>
                    updateSelfCareActivity(activity.externalReference, target.value)
                  }
                  disabled={status === ARCHIVED}
                />
                {status === UPCOMING && selfCareActivities.length > 1 && (
                  <DeleteIcon
                    className="accountability-self-care__delete-icon"
                    onClick={(): void => deleteSelfCareActivity(activity.externalReference)}
                    data-testid="delete-icon"
                  />
                )}
              </div>
            )
          )}
          {status !== ARCHIVED && <Button text="Add" onClick={createSelfCareActivity} />}
        </div>
      )}
    </div>
  );
};

export default AccountabilitySelfCare;
